import React from 'react';
import AppHeader from 'components/header';
import AppFooter from 'components/footer';

const BasedLayout: React.FC = ({ children }) => {

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppHeader />
      {children}
      <AppFooter />
    </div>
  );

};

export default BasedLayout;